import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "App-Reset-Succ",
  "txt-center": ""
}
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { "m-tb-0": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        lazy: "",
        "m-t-1q": "",
        style: `width: 230px;`,
        src: _ctx.img
      }, null, 8, ["src"])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("h2", {
      "f-w-600": "",
      "m-tb-0": "",
      "txt-center": ""
    }, " Hmm... this password reset link isn't valid ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", {
      "txt-center": "",
      "m-tb-0": ""
    }, [
      _createTextVNode(" The link might have expired or "),
      _createElementVNode("br"),
      _createTextVNode(" been used already. ")
    ], -1)),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/forgot" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_link, { type: "primary" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Request a new reset link ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}